import React, { FC } from 'react';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { useTranslation } from 'react-i18next';

interface StorePaymentIntegrationStateBadgeProps {
    state: string;
}

export const StorePaymentIntegrationStateBadge: FC<StorePaymentIntegrationStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        activeLabel: t('store-payment-integration-state.active'),
        inactiveLabel: t('store-payment-integration-state.inactive'),
    };

    switch (state) {
        case 'active':
            return <Badge label={translations.activeLabel} type={BadgeType.success} icon="fa-light fa-check" />;
        case 'inactive':
            return <Badge label={translations.inactiveLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
